import { render, staticRenderFns } from "./content-footer.vue?vue&type=template&id=f6cffda2&scoped=true"
import script from "./content-footer.vue?vue&type=script&lang=js"
export * from "./content-footer.vue?vue&type=script&lang=js"
import style0 from "./content-footer.vue?vue&type=style&index=0&id=f6cffda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cffda2",
  null
  
)

export default component.exports